import React from "react"
import { ArrowRight, Zap } from "lucide-react"
import { useNavigate } from "react-router-dom"

const CreateJobFinalStep = ({ orgId, jobId }) => {
  const navigate = useNavigate()

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700&display=swap'); * { box-sizing: border-box; }`}</style>

      <div style={{ fontFamily: "'DM Sans', sans-serif", maxWidth: 560, paddingBottom: 48 }}>

        {/* Page heading */}
        <div style={{ marginBottom: 28 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, color: "#111827", margin: "0 0 4px", letterSpacing: "-0.02em" }}>
            You're almost done
          </h3>
          <p style={{ fontSize: 13, color: "#6b7280", margin: 0, fontWeight: 400 }}>
            Choose how you want to power your hiring pipeline for this role.
          </p>
        </div>

        {/* Section divider */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#6b7280", whiteSpace: "nowrap" }}>
            Setup Options
          </span>
          <div style={{ flex: 1, height: 1, background: "#f3f4f6" }} />
        </div>

        {/* Option card */}
        <div
          style={{
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 10,
            overflow: "hidden",
          }}
        >
          {/* Card body */}
          <div style={{ display: "flex", alignItems: "flex-start", gap: 16, padding: "20px 20px 18px" }}>
            {/* Icon */}
            <div
              style={{
                flexShrink: 0,
                width: 38,
                height: 38,
                border: "1px solid #e5e7eb",
                borderRadius: 8,
                background: "#f9fafb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Zap size={16} strokeWidth={2.5} style={{ color: "#374151" }} />
            </div>

            <div style={{ flex: 1, minWidth: 0 }}>
              <span
                style={{
                  display: "inline-block",
                  fontSize: 11,
                  fontWeight: 700,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  color: "#6b7280",
                  marginBottom: 4,
                }}
              >
                Recommended
              </span>
              <h4 style={{ fontSize: 14, fontWeight: 700, color: "#111827", margin: "0 0 6px", letterSpacing: "-0.01em" }}>
                Setup AI Interview Round
              </h4>
              <p style={{ fontSize: 13, color: "#6b7280", margin: 0, lineHeight: 1.55, fontWeight: 400 }}>
                Let AI conduct the first interview round to automatically screen and filter candidates based on your job requirements — before any human involvement.
              </p>
            </div>
          </div>

          {/* Card footer */}
          <div
            style={{
              borderTop: "1px solid #f3f4f6",
              padding: "12px 20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "rgb(250,249,245)",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              {["Auto Screening", "Voice + Chat", "Instant Results"].map((tag) => (
                <span
                  key={tag}
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#6b7280",
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    borderRadius: 5,
                    padding: "3px 8px",
                    letterSpacing: "0.01em",
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>

            <button
              type="button"
              onClick={() => navigate(`/jobs/${orgId}/${jobId}/add-ai-interview`)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                padding: "9px 18px",
                fontSize: 13,
                fontWeight: 600,
                color: "#fff",
                background: "#111827",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif",
                letterSpacing: "-0.01em",
                transition: "background 0.12s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#27272a")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#111827")}
            >
              Setup AI Round
              <ArrowRight size={13} strokeWidth={2.5} />
            </button>
          </div>
        </div>

        {/* Skip hint */}
        <p style={{ fontSize: 12, color: "#9ca3af", textAlign: "center", marginTop: 20 }}>
          You can always configure these later from the job settings.
        </p>
      </div>
    </>
  )
}

export default CreateJobFinalStep